import 'jquery';

global.jQuery = $;
global.jquery = $;
global.$ = $;

import svg4everybody from 'svg4everybody/dist/svg4everybody';
import objectFitImages from 'object-fit-images';

import lazyload from 'lazyload'; // удалить!

import '~components/login/login';
import '~components/registration/registration';
import '~components/tabs/tabs';
import '~components/tooltip/tooltip';

import '../scss/common.scss';

$(document).ready(function() {
	// adds SVG External Content support to all browsers
	svg4everybody();

	// Polyfill object-fit/object-position on <img>
	objectFitImages();
});

$(window).on('load', function() {
	$('body').addClass('loaded');

  if (process.env.NODE_ENV === 'development') {
    let img = $('.lazyload')
    let lazy = new lazyload(img);
    lazy.loadImages();
  }

  // закрытие родительского блока при клике на кнопку
  $(document).on('click', '[data-close-block]', function(e) {
    let el = $(this);
		const ww = $(window).width();

		if (!el.closest('form').is('[data-filter]')) {
			el.parent().slideUp('fast');
		} else if (ww < 992) {
			$('body').removeClass('overflow');
      $('html').removeClass('overflow');
		}

    el.closest('form').removeClass('active')
    $('html').removeClass('overflow-hidden')
    $('body').removeClass('overflow-hidden')
    $('body').removeClass('overflow');
    $('html').removeClass('overflow');
    $('page').removeClass('overflow')

    e.preventDefault();
  })

	appHeight();

	$(window).on('resize', function () {
		appHeight();
	})

	$('textarea').on('input', function() {
		let el = this;
		let height = el.scrollHeight;
		el.style.cssText = 'height:auto; padding:0';
		el.style.cssText = 'height:' + height + 'px';

		if (el.value.length < 1) {
			$(el).removeAttr('style');
		}
	});

	$(window).on('scroll', function() {
		let wh = $(window).innerHeight();
		let scroll = $(window).scrollTop();

		if (scroll > wh / 2) {
			$('[data-scroll-to-single]').addClass('show');
		} else {
			$('[data-scroll-to-single]').removeClass('show');
		}
	});


  $('[data-more]').on('click', function(e) {
    let el = $(this);
    let srt = el.attr('data-more').split(',');
		let parentPos = el.parent().offset().top;
		let wh = $(window).height();

    el.prev().toggleClass('show');

    if (el.prev().hasClass('show')) {
      el.text(srt[1])
    } else {
			// $('html, body').animate({scrollTop: parentPos - wh / 2 }, 1000);
      el.text(srt[0])
    }
    e.preventDefault();
  });
});

function appHeight() {
	$('html').css({'--app-height': `${$(window).height()}px`, '--app-vh': `${$(window).height() / 100}px`});
}

import '~components/header/header'
import '~components/hamburger/hamburger'
import '~components/footer/footer'
import '~components/card/card'
import '~components/menu/menu'
import '~components/popup/popup'
import '~components/forms/form/form'
import '~components/forms/input/input'
import '~components/preloader/preloader'
import '~components/i-cookie/i-cookie';
import '~components/j-jamilco/j-jamilco';
import '~components/j-fav/j-fav';
import '~components/cart/cart'
import '~components/forms/select/select'
import '~components/m-cookie/m-cookie'
